




































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { Usuario } from '../../../../back/src/entity/Usuario';
import { Grupo } from '../../../../back/src/entity/Grupo';
import { UsuarioEditFormData } from '../../../../back/src/types';

export default Vue.extend({
  name: 'TheUsuariosEdit',
  props: {
    usuario: {
      type: Object as () => Usuario,
    },
    grupos: {
      type: Array as () => Grupo[],
    },
  },
  data() {
    return {
      loading: {
        submit: false,
      },
      form: {
        nome: this.usuario.nome,
        email: this.usuario.email,
        grupoId: this.usuario.grupo_id,
        ativo: this.usuario.ativo,
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
    };
  },
  computed: {
    itemsGrupos(): { value: number | null, text: string }[] {
      return _.map(
        this.grupos as Grupo[],
        grupo => ({ value: grupo.id || null, text: grupo.nome || '' }),
      );
    },
    formUsuarioEdit():
      Vue & { validate: () => boolean, reset: () => void, resetValidation: () => void } {
      return this.$refs.formUsuarioEdit as Vue & {
        validate: () => boolean,
        reset: () => void,
        resetValidation: () => void
      };
    },
  },
  methods: {
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      if (!this.formUsuarioEdit.validate) {
        return;
      }
      const formData: UsuarioEditFormData = {
        id: this.usuario.id,
        nome: this.form.nome,
        email: this.form.email,
        grupo_id: this.form.grupoId,
        ativo: this.form.ativo,
      };
      this.loading.submit = true;
      try {
        const response = await Requester.usuario.atualizaUsuario(this.usuario.id, formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Usuário atualizado com sucesso' });
          this.$emit('atualizaUsuario', response.data);
          this.edit = false;
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
  },
});
